// eslint-disable-next-line no-restricted-imports
import { api, PopupEventApiType } from '@b2x/storefront-api-js-client/src';
import { GetPopupByIdOptions, HandlePopupsOptions } from '@b2x/storefront-api-js-client/src/popups';
import React from 'react';

import { PopupContentTypeV2 } from '../contentTypes';
import { ApiRequestConfig, useApiRequest } from './useApiRequest';

export const usePopupsApi = () => {
  const { apiRequest } = useApiRequest();

  const handlePopups = React.useCallback(
    (
      event: PopupEventApiType,
      url: string,
      popupsToExclude: Array<string>,
      options?: HandlePopupsOptions,
      config?: ApiRequestConfig
    ) => apiRequest(api.popups.handlePopups<PopupContentTypeV2>(event, url, popupsToExclude, options), { ...config }),
    [apiRequest]
  );

  return { handlePopups };
};

export const useGetPopupById = () => {
  const { apiRequest } = useApiRequest();

  const getPopupById = React.useCallback(
    (id: string, options?: GetPopupByIdOptions) => apiRequest(api.popups.getPopupById<PopupContentTypeV2>(id, options)),
    [apiRequest]
  );

  return { getPopupById };
};
